import React, { PureComponent } from 'react'
import { func } from 'prop-types'
import Form from '@active/react-ui/Form'
import FormGroup from '@active/react-ui/FormGroup'
import FormLabel from '@active/react-ui/FormLabel'
import FormStaticField from '@active/react-ui/FormStaticField'
import { Locale, withI18n } from '@active/react-utils/i18n'
import Popover from '@active/react-ui/Popover'
import { paymentMethodPropType } from '../../../../common/paymentMethodTypes'
import './SavedEUDD.scss'

const formatter = () => <Locale id="passport.lib.components.payment.eudd.label" />

class SavedEUDD extends PureComponent {
  static propTypes = {
    paymentMethod: paymentMethodPropType.isRequired,
    i18n: func.isRequired,
  }

  render() {
    const { paymentMethod, i18n } = this.props
    return (
      <div className="checkout__saved-eu checkout-payments">
        <Form horizontal initialValues={paymentMethod}>
          <FormGroup>
            <FormLabel><Locale id="passport.lib.components.payment.ecpeudd.type" /></FormLabel>
            <FormStaticField name="paymentType" formatter={formatter} />
            <Popover content={Locale({ id: 'passport.lib.components.payment.eudd.hint' })} style={{ zIndex: 10 }} placement="top-start" theme="dark">
              <i className="ic-question-r" />
            </Popover>
          </FormGroup>
          <FormGroup>
            <FormLabel><Locale id="passport.lib.components.payment.eudd.iban" /></FormLabel>
            <FormStaticField
              name="last2Digits"
              formatter={name => (i18n('passport.lib.components.payment.4asterisk') + name)}
            />
          </FormGroup>
          <FormGroup>
            <FormLabel><Locale id="passport.lib.components.payment.echeck.name" /></FormLabel>
            <FormStaticField name="accountName" />
          </FormGroup>
        </Form>
      </div>
    )
  }
}

export default withI18n(SavedEUDD)
